import React from "react";
import styled from "styled-components";
import ReactPlayer from 'react-player'
import Image from 'react-bootstrap/Image'
import Linkify from 'react-linkify';

const Section = styled.section`
  padding: 0px 0 0px;
`;
const SectionTitle = styled.h2`
  font-size: 56px;
  font-weight: 300;
  line-height: normal;
  color: #1b5cce;
  text-align: center;
  margin-bottom: 20px;
  font-family: Open Sas;
`;


const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
  &:hover {
    transform: translateY(-5px) !important;
  }

  @media (min-width: 992px) {
    margin-bottom: 0;
  }
`;
const BoxTitle = styled.h4`
  font-size: 30px;
  font-weight: 300;
  line-height: normal;
  color: #5273c7;
  font-family: Open Sas;
`;

const BoxSubTitle = styled.h4`
  font-size: 20px;
  font-weight: 100;
  line-height: normal;
  color: #5273c7;
  font-family: Open Sas;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: normal;
  line-height: 1.58;
  color: #8f8f8f;
  margin-bottom: 0;
  max-width: 720px;
  text-align:left;
  font-family: Open Sas;
`;

const Research = () => {

  const width = window.innerWidth;
  return (
    <Section id="research">
      <div>
      <div className="col-lg-12">
        <SectionTitle>Active Research Projects</SectionTitle>
        {/* <SubTitle>Lorem ipsum dolor sit amet</SubTitle> */}
        <div className="row">
          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-right" : "fade-up"}>
              <div style={{marginBottom:40}}>
              <Image src={require ("../assets/img/deep.png")} width='100%' height='366px' roundedCircle />
              {/* <ReactPlayer width='360px' height='180px' url='https://www.youtube.com/watch?v=khRkq6I3VJk' /> */}
              {/* <ReactPlayer width='720px' height='360px' url =' https://www.youtube.com/watch?v=4vbQZ8bf9YI&feature=youtu.be' /> */}
              </div>
              <BoxTitle>Deep Insight</BoxTitle>
              <BoxSubTitle>FHWA - 2019 - 2022</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              This project designs, develops, and demonstrate advanced behavior analysis for driving assistance. 
              Our purposes include crash avoidance and driving assistance through detection, tracking and identification of faces 
              inside the vehicle as well as other objects (pedestrians, cars, traffic signs and signals) around vehicle. We are going 
              to employ state-of-the-art computer vision techniques while investigating novel annotation and object attributes for the 
              purpose of improving the detection and recognition of algorithms especially for real life recordings of naturalistic driving.

              </Text>
            </Box>
          </div>
          <div className="col-lg-6">
            <Box data-aos="fade-up">
              <div style={{marginBottom:40}}>
              <Image src={require ("../assets/img/titan_2.png")} width='100%' height='366px' roundedCircle />
              {/* <ReactPlayer width='360px' height='180px' url='https://www.youtube.com/watch?v=khRkq6I3VJk' /> */}
              </div>
              <BoxTitle>DASH - Modern Integrated Data Wareshousing</BoxTitle>
              <BoxSubTitle>St Charles County Government - 2019 - 2022</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              DASH utilizes emerging paradigms in “Big Data” to develop a highly scalable, secure, 
              cloud-based data warehousing platform that is capable of ingesting, processing, and visualizing disparate transportation 
              datasets that are too large or complex for traditional database systems. The proposed solution will overcome the 
              challenges of traditional transportation data management systems by providing a framework for seamless integration of disparate datasets, 
              and real-time visual analytics.
              </Text>
            </Box>
          </div>
          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
              <div style={{marginBottom:40}}>
              <Image src={require ("../assets/img/mimic.png")} width='100%' height='366px' roundedCircle />
              {/* <ReactPlayer width='360px' height='180px' url='https://www.youtube.com/watch?v=khRkq6I3VJk' /> */}
              </div>
              <BoxTitle>MIMIC - Artificial Realist Data Integration</BoxTitle>
              <BoxSubTitle>FHWA - 2019 - 2022</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              This EARP project will generate artificial realistic datasets (ARD) that will mimic the known causal relationships 
              between variables and crashes. The datasets will then be used by experts to discover the best statistical and machine 
              learning methods that will replicate these causal relationships. Thus, the best performing methods can be applied by 
              practitioners, with confidence, in safety evaluation and countermeasure selection. 

              </Text>
            </Box>
          </div>

          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
              <div style={{marginBottom:40}}>
              <Image src={require ("../assets/img/av.png")} width='100%' height='366px' roundedCircle />
              {/* <ReactPlayer width='360px' height='180px' url='https://www.youtube.com/watch?v=khRkq6I3VJk' /> */}
              </div>
              <BoxTitle>Investigation of AVs in Workzones</BoxTitle>
              <BoxSubTitle>Smart Workzone Pooled Fund - 2019 - 2020</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              A trucking/driving simulator study to analyze the issues surrounding truck platooning near lane closure work zones is proposed. 
              The study will utilize truck drivers with commercial driving licenses and observe how truck drivers and other human drivers 
              behave as they interact near work zones. The study results will help to inform policies on truck platooning near work zones 
              such as how should truck platoons behave when approaching work zones. 

              </Text>
            </Box>
          </div>
          <Linkify>
          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <div style={{marginBottom:40}}>
            <ReactPlayer width='720px' height='360px' url =' https://www.youtube.com/watch?v=4vbQZ8bf9YI&feature=youtu.be' />
              </div>
              <BoxTitle>TITAN - Interactive Visual Analytics For Big  Data</BoxTitle>
              <BoxSubTitle>Missouri Department of Transportation - 2018 - 2019</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              This project proposes a prototype design and deployment of TITAN 
              (Transportation data InTegration and Analytics), an interactive, web-based platform that will assist decision makers 
              at MoDOT to seamlessly integrate and analyze its transportation datasets (including freight). The  platform will 
              be significantly faster and cheaper (by using open-sourced software solutions for development) compared to conventional 
              data warehouses, which are heavily reliant on relational databases housed in big, costly enterprise machines. 
              Explore TITAN at: https://mizzou-titan.com/
              </Text>
            </Box>
          </div> 
          </Linkify>
          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <div style={{marginBottom:40}}>
            <Image src={require ("../assets/img/swzapp.png")} width='100%' height='366px' roundedCircle />
              {/* <ReactPlayer width='360px' height='180px' url='https://www.youtube.com/watch?v=khRkq6I3VJk' /> */}
              </div>
              <BoxTitle>SWIZAPP - Workzone Activity App</BoxTitle>
              <BoxSubTitle>Smart Workzone Pooled Fund - 2018 - 2019</BoxSubTitle>
              <Text style={{marginBottom:20}}>
              As mobile computing platforms grow in capabilities such as the inclusion of a variety of sensors 
              (e.g., GPS, accelerometer, magnetometer, gyroscope), they represent new sources of valuable individual-based data. 
              This project developed a mobile application, SWiZAPP, for the accurate and timely communication of real-time work-zone 
              activities to departments of transportation staff, traffic management centers, work-zone contractors, and the travelling public. 
              The app supports automatic geolocation and mapping via on-board GPS sensors. 
              Users are required to create accounts via the login screen which enables the app to securely log, track and monitor their 
              activities. 

              </Text>
            </Box>
          </div>

          <div className="col-lg-6">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <div style={{marginBottom:40}}>
              <ReactPlayer width='720px' height='360px' url='https://youtu.be/a2BNVpgGvPM' />
              </div>
              <BoxTitle>Freight Data Integration and Analytics</BoxTitle>
              <BoxSubTitle>Florida Atlantic University - 2018 - 2019</BoxSubTitle>
              <Text style={{marginBottom:40}}>
              The lack of coordination among freight data vendors not only prevents the seamless integration of data sources but
               also disables data-driven decision making. The need for frameworks that can help integrate and analyze information 
               from existing freight databases is therefore crucial. Under the above context, this project seeks to develop 
               a user-friendly, interactive, web-based prototype platform that takes advantage of recent advances in spatial data analysis, 
               big data and user-centered visualization to integrate freight data across different private and public databases for the 
               purpose of improving freight planning activities and data driven decision making.
              </Text>
            </Box>
          </div>
        </div>
      </div>
      </div>
    </Section>
  );
};

export default Research;
